import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Table, Input, Button} from 'semantic-ui-react';
import {enterKeyCode, tabKeyCode} from '../../../../../../common/constants/keyCodes';
import {validateUnique} from '../../../../../utils';
import {Actions} from '../../../../../../common/actions';

const FormParts = (props) => {
  const {
    oldId,
    newId,
    quantity,
    description,
    handleChange,
    handleAddItem,
    handleKeyDown,
    loading,
  } = props;
  const isNotTdePart = oldId && !description;
  const validateBtn = !newId || isNotTdePart || !quantity || +quantity === 0;

  return (
    <Table.Row textAlign='center'>
      <Table.Cell width={3}>
        <Input
          disabled={loading}
          className='twc-works-input'
          placeholder='No. de parte nuevo'
          value={newId}
          required
          onChange={(e, {value}) => handleChange('newId', value)}
        />
      </Table.Cell>
      <Table.Cell width={3}>
        <Input
          disabled={loading}
          onKeyDown={handleKeyDown}
          className='twc-works-input'
          placeholder='No. de parte antiguo'
          value={oldId}
          onChange={(e, {value}) => handleChange('oldId', value)}
        />
      </Table.Cell>
      <Table.Cell width={4}>{description}</Table.Cell>
      <Table.Cell width={3}>
        <Input
          disabled={loading}
          className='twc-works-input'
          value={quantity}
          type='number'
          required
          min='0'
          onChange={(e, {value}) => handleChange('quantity', value)}
        />
      </Table.Cell>
      <Table.Cell width={2}>
        <Button
          disabled={validateBtn}
          onClick={() => handleAddItem()}
          size='mini'
          color='green'
        >
          Agregar
        </Button>
      </Table.Cell>
    </Table.Row>
  );
};

const DisplayData = ({
  item,
  handleRemoveItem,
  idx,
  disabledBtns,
}) => {
  const {oldId, newId, description, quantity} = item;
  return (
    <Table.Row textAlign='center'>
      <Table.Cell width={4}>{newId}</Table.Cell>
      <Table.Cell width={4}>{oldId}</Table.Cell>
      <Table.Cell width={4}>{description}</Table.Cell>
      <Table.Cell>{quantity}</Table.Cell>
      {!disabledBtns && (
        <Table.Cell width={2}>
          <Button
            disabled={disabledBtns}
            onClick={() => handleRemoveItem(idx)}
            size='mini'
            color='red'
          >
            Eliminar
          </Button>
        </Table.Cell>
      )}
    </Table.Row>
  );
};

const initialState = {
  'oldId': '',
  'newId': '',
  'description': '',
  'quantity': '',
  'searchPart': false,
};

class Parts extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ...initialState,
    };
  }

  handleAddItem = (e) => {
    const {onUpdateForm} = this.props;
    const {newId, oldId, description, quantity} = this.state;
    const newParts = [...this.props.parts];
    const item = {newId, oldId, description, 'quantity': +quantity};
    if (validateUnique(newParts, 'newId', newId)) {
      newParts.push(item);
      this.setState(
        {
          ...initialState,
        },
        () => {
          onUpdateForm(e, {'name': 'parts', 'value': newParts});
        }
      );
    } else {
      this.props.addMessageBoxError(
        `El item ${newId} ya se encuentra en la lista`
      );
    }
  };

  handleRemoveItem = (id) => {
    const {onUpdateForm} = this.props;
    const e = '';
    const parts = [...this.props.parts].filter((item, idx) => idx !== id);
    onUpdateForm(e, {'name': 'parts', 'value': parts});
  };

  componentDidUpdate() {
    const {part} = this.props;
    if (this.state.oldId === part.code && this.state.searchPart) {
      this.setState({
        'description': part.name,
        'searchPart': false,
      });
    }
  }

  handleChange = (field, value) => {
    this.setState({
      [field]: value,
      'description': field === 'oldId' ? '' : this.state.description,
    });
  };

  handleKeyDown = (e) => {
    const {oldId} = this.state;
    if (e.keyCode === enterKeyCode || e.keyCode === tabKeyCode) {
      if (oldId.length > 1) {
        this.props.getWarrantyPart(oldId);
        this.setState({'searchPart': true});
      }
      e.preventDefault();
    }
  };

  render() {
    const {loading, parts = [], edit} = this.props;
    return (
      <div>
        <div className="warranty-container-table">
          <Table celled>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>No. de parte nuevo</Table.HeaderCell>
                <Table.HeaderCell>No. de parte antiguo</Table.HeaderCell>
                <Table.HeaderCell>Descripción</Table.HeaderCell>
                <Table.HeaderCell>Cantidad</Table.HeaderCell>
                {edit && (<Table.HeaderCell></Table.HeaderCell>)}
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {edit && (
                <FormParts
                  handleChange={this.handleChange}
                  {...this.state}
                  handleAddItem={this.handleAddItem}
                  handleKeyDown={this.handleKeyDown}
                  loading={loading}
                />
              )}
              {!parts.length ? (
                <Table.Row>
                  <Table.Cell colSpan={15} textAlign='center'>
                    No hay datos disponibles
                  </Table.Cell>
                </Table.Row>
              ) : (
                parts.map((part, idx) => (
                  <DisplayData
                    disabledBtns={!edit}
                    handleUpdateAmount={this.handleUpdateAmount}
                    key={idx}
                    item={part}
                    idx={idx}
                    handleRemoveItem={this.handleRemoveItem}
                  />
                )
                ))}
            </Table.Body>
          </Table>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loading': state.warrantiesCategories.loading,
    'part': state.warrantiesCategories.part,
  };
};

const {getWarrantyPart, addMessageBoxError} = Actions;

export default connect(mapStateToProps, {
  getWarrantyPart,
  addMessageBoxError,
})(Parts);
